export const SPRITE_SIZE = 32;
export const SCREEN_WIDTH = SPRITE_SIZE * 25;
export const SCREEN_HEIGHT = SPRITE_SIZE * 25;

export const FLOOR_TILE = 0;
export const WALL_TILE = 1;
export const PLAYER_TILE = 2;
export const ENEMY_TILE = 3;

export const DIRECTIONS = {
    RIGHT: 'Right',
    LEFT: 'Left',
    DOWN: 'Down',
    UP: 'Up'
};

// settings for generation
export const DIMENSIONS = 32;
export const MAX_TUNNELS = 150;
export const MAX_LENGTH = 8;

